__turbopack_context__.v({
  "powerBy": "index-module-scss-module__5ZFNeW__powerBy",
});
